import React from "react";
import { Modal, Dropdown } from "react-bootstrap";
import styled from "styled-components";
import {
  Search,
  ChevronRight,
  Wallet,
  ArrowDownUp,
  Vault,
  WalletCards,
} from "lucide-react";
import PerfectScrollbar from "perfect-scrollbar";
import "perfect-scrollbar/css/perfect-scrollbar.css";
import { __, wait, decode, encode, forceSatoshiFormat, Event, API } from 'utils/Helper';
import socket from "utils/Socket";
import storage from "utils/Storage";
import C from 'utils/Constant';
import coins from "utils/coins";
import axios from "axios";

const SearchContainer = styled.div`
  display: flex;
  align-items: center;
  background-color: #2b2f30;
  border: 1px solid #3a4142;
  border-radius: 10px;
  padding: 8px 12px;
  margin: 0px 15px 10px 15px;
`;

const SearchInput = styled.input`
  border: none;
  background: transparent;
  margin-left: 8px;
  flex-grow: 1;
  &:focus {
    outline: none;
  }
`;

const ManageListButton = styled.button`
  background: none;
  border: none;
  font-size: 15px;
  color: #aeb9bc !important;
  font-weight: 700;
  cursor: pointer;
  &:hover {
    text-decoration: underline;
  }
`;

const Divider = styled.hr`
  margin: 16px 0;
  border-top: 1px solid #e0e0e0;
`;

const ResponsiveModal = styled(Modal)`
  .modal-dialog {
    height: 80vh !imporatnt;
  }
`;
const ModalHeader = styled(Modal.Header)`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1rem;
  border-bottom: 1px solid #e9ecef;
`;

class CoinSelection extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      show: false,
      showManage: false,
      isTransferIn: true,
      token: storage.getKey("token"),
      coin: this.props.coin ? this.props.coin : (storage.getKey("coin") ? storage.getKey("coin") : "inr"),
      activeClientCoins: storage.getKey("active_coins")
        ? storage.getKey("active_coins")
        : null,
      selectedCoin: this.props.coin ? this.props.coin : storage.getKey("coin"),
      credits: {},
      coins: [],
      manage_coins: [],
      different: [],
      credit: false,
      usd: storage.getKey("usd") === "true" ? true : false,
      searchTerm: "",
      showWalletModal: false,
      showCurrencyModal: false,
      activeSection: "deposit",
      activeDbCurrencies: [],
    };
    this.selectCoin = this.selectCoin.bind(this);
    this.wrapperRef = React.createRef();
    this.handleClickOutside = this.handleClickOutside.bind(this);
    this.sections = [
      { id: "deposit", label: "Deposit", icon: Wallet },
      { id: "withdraw", label: "Withdraw", icon: WalletCards },
      { id: "swap", label: "Swap", icon: ArrowDownUp },
      { id: "vaultpro", label: "Vault Pro", icon: Vault },
    ];
  }

  componentDidMount() {
    if (this.state.token !== null)
      socket.emit(
        C.CREDIT,
        encode({ token: this.state.token, coin: this.state.coin })
      );

    socket.on(C.CREDIT, (data) => this.getCredit(decode(data)));
    socket.on(C.UPDATE_CREDIT, (data) => this.updateCredit(decode(data)));

    if (this.state.activeClientCoins === null) {
      var arr = [];
      for (var i = 1; i < 8; i++) {
        arr.push(i);
      }
      storage.setKey("active_coins", arr);
    }

    axios.get(`${API}/api/currencies`)
      .then((res) => {
        if (res.data && res.data.success) {
          window.activeDbCurrencies = res.data.currencies;
          this.setState({ activeDbCurrencies: res.data.currencies }, () => {
            this.updateAllCoins();
            this.setUpManageCoins();
          });
        }
      })
      .catch((err) => {
        console.error("Error fetching active currencies:", err);
      });

    this.setUpManageCoins();

    window.addEventListener("mousedown", this.handleClickOutside);
  }

  componentWillUnmount() {
    window.removeEventListener("mousedown", this.handleClickOutside);
  }

  handleClickOutside(event) {
    if (this.wrapperRef && !this.wrapperRef.current.contains(event.target)) {
      this.setState({ show: false });
    }
  }

  getCredit(data) {
    let { credit } = data;

    this.setState({ credits: credit });

    let currentCoin = __.lowerCase(this.props.coin);
    let currentCredit = forceSatoshiFormat(this.state.credits[currentCoin]);
    this.setState({ credit: currentCredit });

    this.props.setCredit(currentCredit);
    this.updateAllCoins();
  }

  updateCredit(data) {
    let credit = data.value;
    let coin = data.coin;

    let different;
    let arr;

    if (__.toNumber(credit) > __.toNumber(this.state.credit)) {
      different = __.toNumber(credit) - __.toNumber(this.state.credit);
      arr = {
        amount: different,
        color: "text-success",
      };
    } else {
      different = __.toNumber(this.state.credit) - __.toNumber(credit);
      arr = {
        amount: different,
        color: "text-danger",
      };
    }

    let check = forceSatoshiFormat(different);

    if (check.toString() !== "0.00000000") {
      this.setState((state) => ({ different: [arr, ...state.different] }));
    }

    var realCredit = credit;
    credit = forceSatoshiFormat(credit);

    this.setState({ credit: credit });

    if (this.updateParentCoin) {
      this.updateParentCoin(__.lowerCase(coin), credit);
    }
    this.updateAllCoins(__.lowerCase(coin), realCredit);

    this.props.setCredit(credit);
  }

  updateAllCoins(newCoin = null, newVal = null) {
    const activeClientCoins = storage.getKey("active_coins");
    this.setState({ coins: [] });

    let ac = null,
      style,
      value,
      coin;

    const { activeDbCurrencies } = this.state;
    if (!activeDbCurrencies || activeDbCurrencies.length === 0) return;

    if (activeClientCoins !== null) {
      ac = activeClientCoins.split(",");

      __.reverse(ac).forEach((num, key) => {
        var item = __.find(coins, { id: parseFloat(num) });
        if (__.isUndefined(item)) return;

        const dbCoin = activeDbCurrencies.find(c => c.code.toLowerCase() === item.preffix.toLowerCase());
        if (!dbCoin) return;
        style =
          __.lowerCase(item.preffix) === __.lowerCase(this.state.selectedCoin)
            ? "actc height-highlight"
            : "";

        if (newVal !== null) value = newVal;
        else
          value = forceSatoshiFormat(
            this.state.credits[__.lowerCase(item.preffix)]
          );

        if (__.lowerCase(item.preffix) === newCoin) {
          this.state.credits[newCoin] = value;
        }

        if (newCoin !== null) {
          coin = (
            <Dropdown.Item
              onClick={(e) => this.selectCoin(item.preffix, newCoin, newVal)}
              key={key}
              style={{ margin: "30px 0" }}
              className={"num-style " + style}
            >
              <div
                style={{ color: "white", margin: "14px 0" }}
                className="float-left"
              >
                <img
                  src={"/assets/images/" + item.image}
                  alt="coin"
                  className={"mini-coin-7"}
                />
                {item.preffix}
              </div>
              {__.lowerCase(item.preffix) === newCoin ? (
                <div
                  style={{ color: "white", margin: "14px 0" }}
                  className="float-right"
                >
                  {value}
                </div>
              ) : (
                <div
                  style={{ color: "white", margin: "14px 0" }}
                  className="float-right"
                >
                  {forceSatoshiFormat(
                    this.state.credits[__.lowerCase(item.preffix)]
                  )}
                </div>
              )}
            </Dropdown.Item>
          );
        } else {
          coin = (
            <Dropdown.Item
              onClick={(e) => this.selectCoin(item.preffix)}
              key={key}
              style={{ margin: "30px 0" }}
              className={"num-style " + style}
            >
              <div
                style={{ color: "white", margin: "14px 0" }}
                className="float-left"
              >
                <img
                  src={"/assets/images/" + item.image}
                  alt="coin"
                  className={"mini-coin-7"}
                />
                {item.preffix}
              </div>
              <div
                style={{ color: "white", margin: "14px 0" }}
                className="float-right"
              >
                {value}
              </div>
            </Dropdown.Item>
          );
        }

        this.setState((state) => ({ coins: [coin, ...state.coins] }));
      });
    } else {
      coins.forEach((item, key) => {
        const dbCoin = activeDbCurrencies.find(c => c.code.toLowerCase() === item.preffix.toLowerCase());
        if (!dbCoin) return;

        style =
          __.lowerCase(item.preffix) === __.lowerCase(this.state.selectedCoin)
            ? "actc"
            : "";
        value = forceSatoshiFormat(
          this.state.credits[__.lowerCase(item.preffix)]
        );
        coin = (
          <Dropdown.Item
            onClick={(e) => this.selectCoin(item.preffix)}
            key={key}
            style={{ margin: "30px 0" }}
            className={"num-style " + style}
          >
            <div
              style={{ color: "white", margin: "14px 0" }}
              className="float-left"
            >
              <img
                src={"/assets/images/" + item.image}
                alt="coin"
                className={"mini-coin-7"}
              />
              {item.preffix}
            </div>
            <div
              style={{ color: "white", margin: "14px 0" }}
              className="float-right"
            >
              {value}
            </div>
          </Dropdown.Item>
        );
        this.setState((state) => ({ coins: [coin, ...state.coins] }));
      });
    }
  }

  selectCoin(name, newCoin, newVal) {
    if (this.props.coin === name) {
      if (this.props.onClose) {
        this.props.onClose();
      }
      return;
    }

    let credit = this.state.credits[__.lowerCase(name)];
    this.setState({ coin: name, credit: credit, selectedCoin: name });

    this.props.setCoin(name);
    this.props.setCredit(credit);

    wait(200).then(() => {
      this.updateAllCoins(newCoin, newVal);
      if (this.props.onClose) {
        this.props.onClose();
      }
    });
  }

  setUpManageCoins = () => {
    const activeCoins = storage.getKey("active_coins");
    let ac = __.split(activeCoins, ",");
    this.setState({ manage_coins: [] });

    const { activeDbCurrencies } = this.state;
    if (!activeDbCurrencies || activeDbCurrencies.length === 0) return;

    coins.forEach((item, key) => {
      const dbCoin = activeDbCurrencies.find(c => c.code.toLowerCase() === item.preffix.toLowerCase());
      if (!dbCoin) return;

      let active = ac.some(
        (element) => parseFloat(element) === parseFloat(item.id)
      );
      let disabled = item.preffix === "BTC";

      let add = (
        <Dropdown.Item key={key} className={"num-style"}>
          <div className="float-left text-white ncpt">
            <img
              src={"/assets/images/" + item.image}
              alt="coin"
              className={"mini-coin-12"}
            />
            {item.preffix}
          </div>
          <div className="float-right">
            <div className="custom-control custom-switch switch-success">
              <input
                type="checkbox"
                className="custom-control-input"
                id={"switch_" + key}
                checked={active}
                disabled={disabled}
              />
              <label
                onClick={(e) =>
                  this.activeCoinChange(parseFloat(item.id), active)
                }
                className="custom-control-label"
                htmlFor={"switch_" + key}
              >
                {item.name}
              </label>
            </div>
          </div>
        </Dropdown.Item>
      );
      this.setState((state) => ({
        manage_coins: [add, ...state.manage_coins],
      }));
    });
  };

  activeCoinChange = (id, active) => {
    if (id === 1) return;
    const activeClientCoins = storage.getKey("active_coins");
    let update;

    if (!active) {
      update = activeClientCoins + "," + id;
    } else {
      update = __.replace(activeClientCoins, "," + id, "");
    }

    update = __.replace(update, null, "");

    const compareNumbers = (a, b) => a - b;

    let arr = [];

    const regex = /(\d+)/gi;
    let m;

    while ((m = regex.exec(update)) !== null) {
      if (m.index === regex.lastIndex) {
        regex.lastIndex++;
      }
      m.forEach((match, groupIndex) => {
        match = parseFloat(match);
        arr.push(match);
      });
    }

    arr.sort(compareNumbers);
    var c = __.xor(arr);

    storage.setKey("active_coins", c);

    this.setUpManageCoins();
  };

  handleSearch = (e) => {
    this.setState({ searchTerm: e.target.value });
  };

  usdformat = () => {
    this.setState({ usd: !this.state.usd });
    wait(1000).then(() => {
      storage.setKey("usd", this.state.usd);
    });
  };

  filteredCoins = () => {
    const { searchTerm, coins } = this.state;
    return coins.filter((coin) => {
      const coinText = coin.props.children
        .map((child) => {
          if (typeof child === "string") {
            return child.toLowerCase();
          }
          return "";
        })
        .join(" ");
      return coinText.includes(searchTerm.toLowerCase());
    });
  };

  render() {
    const { credit, different, coin, coins, show, searchTerm, usd } =
      this.state;
    const filteredCoins = this.filteredCoins();

    return (
      <div ref={this.wrapperRef}>
        <SearchContainer>
          <Search color="#636A73" size={16} />
          <SearchInput
            type="text"
            placeholder="Search coins..."
            value={searchTerm}
            onChange={this.handleSearch}
          />
        </SearchContainer>
        <div style={{ height: "500px", overflowY: "auto" }}>
          {filteredCoins}
        </div>
        <Divider />
        <div
          style={{
            margin: "15px",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <ManageListButton onClick={this.setUpManageCoins}>
            Manage List
          </ManageListButton>

          <div className="custom-control custom-switch switch-info">
            <input
              type="checkbox"
              className="custom-control-input"
              id="usdSwitch"
              checked={usd}
              onChange={this.usdformat}
            />
            <label className="custom-control-label" htmlFor="usdSwitch">
              View in USD
            </label>
          </div>
        </div>
      </div>
    );
  }
}

const CoinSelectionModal = ({ isOpen, setCoin, setCredit, coin, onClose }) => {
  return (
    <>
      <ResponsiveModal show={isOpen} onHide={onClose}>
        <ModalHeader>
          <div
            style={{
              fontSize: "14px",
              textTransform: "capitalize",
              fontWeight: "bold",
              color: "#B3BEC1",
            }}
          >
            Coin
          </div>
          <div className="vip2-popup-page-btn-deposit-inner" onClick={onClose}>
            X
          </div>

          {/* <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              margin: "15px",
            }}
          >
            <div
              style={{
                fontSize: "14px",
                textTransform: "capitalize",
                fontWeight: "bold",
                color: "#B3BEC1",
              }}
            >
              Choose Coin
            </div>
            <div
              className="vip2-popup-page-btn-deposit-inner"
              onClick={onClose}
            >
              X
            </div>
          </div> */}
        </ModalHeader>
        <Modal.Body>
          {isOpen && (
            <CoinSelection
              setCoin={setCoin}
              setCredit={setCredit}
              coin={coin}
              onClose={onClose}
            />
          )}
        </Modal.Body>
      </ResponsiveModal>
    </>
  );
};

export default CoinSelectionModal;
